














helpers = require('../../helpers.coffee')

view_model = {
  props:
    user: {}
    user_index:
      default: -1
      type: Number

    showCheckbox:
      default: false

    listCarousel:
      default: false

    userIsSelected:
      default: false

  data: ->
    current_user: Session.current_user

  methods:
    checkboxSelectUser: (user)  ->
      @$emit 'user-selected', user

}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/users/list_copy.vue